import Paper from 'components/Paper/Paper';
import SEO from 'components/SEO';
import ProfileSection from './sections/ProfileSection/ProfileSection';
import useUser from 'hooks/useUser';
import PasswordSection from './sections/PasswordSection/PasswordSection';
import EmailSection from './sections/EmailSection';
import MarketingSection from './sections/MarketingSection/MarketingSection';
import DeleteSection from './sections/DeleteSection';

const Account = () => {
  const user = useUser();

  return (
    <>
      <SEO title="계정 설정" />
      <Paper title="내 계정 관리">
        {user?.data && (
          <>
            <ProfileSection />
            <EmailSection />
            <PasswordSection />
            <MarketingSection />
            <DeleteSection />
          </>
        )}
      </Paper>
    </>
  );
};

export default Account;
